class MyKnowledgeFullModalController {
    
    constructor() {
        this.template = Handlebars.compile($("#myKnowledgeFullModal").html());
        this.menuTemplate = Handlebars.compile($("#fullModalMenu").html());
        this.catList = {};
        this.openSubChart();
    };

    draw(){
        if(!chartSocket){
            chartSocket = api.quizSoquet();
        }
        api.getCategoriesInfo(this.onCategoriesInfoResponse.bind(this));
    };

    onCategoriesInfoResponse(response) {
        if (response.success) {
            this.catList = {};
            let that = this;

            // Convert progress
            for (let i = 0; i < response.result.categories_user.length; i++) {
                let category = response.result.categories_user[i].category;
                category.progressPercent = Math.floor(parseFloat(category.progress)*100);
                category.hasSubcategories = category.subcategories.length > 0;

                if(category.hasSubcategories)
                    this.catList[category.id] = category;
            }

            baseController.resetStackableOrder();
            baseController.stackSimpleMenu({ title: 'TR_MI_CONOCIMIENTO' }, this.menuTemplate);

            api.getChartToken(function (responseToken) {
                var context = {
                    world: world,
                    categories: response.result.categories_user,
                    num_categories: world.num_categories,
                    user: user,
                    socket_id: chartSocket.id,
                    token: responseToken.token
                };
                baseController.stackSimpleContent(that.template, context, 'GAME');

                $('#my-knowledge-list').find('.my-knowledge-list-element-progress').each((i, elem) => {
                    elem = $(elem);
                    let progress = parseInt(elem.attr('data-progress'));
                    createProgressChart(elem, progress);
                });

                let performanceChart = $('#my-knowledge-performance-chart');

                if(performanceChart.length)
                    setTimeout(MyKnowledgeFullModalController.adjustHeight.bind(this), 50);

                performanceChart
                    .off('chart.shown', MyKnowledgeFullModalController.adjustHeight.bind(this))
                    .on('chart.shown', MyKnowledgeFullModalController.adjustHeight.bind(this));

                chartSocket.on(SocketEvents.KNOWLEDGE_LIST_RESPONSE(), function (response) {
                    if(response.success && $(".stackable").last().hasClass('my-knowledge')){
                        that.loadSubcategoryInfo(that.catList, response.cat_id);
                    }
                });

                let height = 40;

                if ($(window).width() <= 420) {
                    height = 30;
                }

                $('.my-knowledge-list-element-name').dotdotdot({
                    height: height,
                    watch: 'true',
                    truncate: 'letter'
                });

            });
        }
    }

    static adjustHeight() {
        let table = $('#my-knowledge-performance-chart-subcategories');

        if(!table.length)
            table = $('#my-knowledge-performance-chart');

        let tableTop = table.offset().top;
        let tableBottom = tableTop + table.outerHeight();

        let windowHeight = $(window).height();

        let diff = windowHeight - tableBottom;
        if (diff > 0) {
            let tableHeight = table.outerHeight();
            table.outerHeight(tableHeight + diff);
        }

        let spinner = $('.chartSpinner');
        let iframe = $('.chartIframe');

        let childHeight = (iframe.outerHeight() > 0) ? iframe.outerHeight() : spinner.outerHeight;
        table.css('padding-top', (table.outerHeight() - childHeight) / 2);

    }

    loadSubcategoryInfo(catList, catId){
        let subCatList = [];
        let that = this;

        // Convert progress
        for (let i = 0; i < catList[catId]['subcategories'].length; i++) {
            let category = catList[catId]['subcategories'][i];

            category.progressPercent = Math.floor(parseFloat(category.progress)*100);
            subCatList.push({category: category});
        }

        api.getChartToken(function (responseToken) {

            let context = {
                world: world,
                num_categories: subCatList.length,
                user: user,
                categories: subCatList,
                parentCategory: catList[catId],
                token: responseToken.token
            };
            baseController.stackSimpleContent(that.template, context);

            $('#my-knowledge-list-subcategories').find('.my-knowledge-list-element-progress').each((i, elem) => {
                elem = $(elem);
                let progress = parseInt(elem.attr('data-progress'));
                createProgressChart(elem, progress);
            });

            let performanceChartSub = $('#my-knowledge-performance-chart-subcategories');

            if (performanceChartSub.length)
                setTimeout(MyKnowledgeFullModalController.adjustHeight.bind(this), 50);

            performanceChartSub
                .off('chart.shown', MyKnowledgeFullModalController.adjustHeight.bind(this))
                .on('chart.shown', MyKnowledgeFullModalController.adjustHeight.bind(this));

            $(".chart-subcategory-back-btn .back-btn").one('click', function (e) {
                e.stopImmediatePropagation();
                $('.stackable').last().remove();
                $('.stackable').last().show();
            });

            $("#documentation-header-close-btn").one('click', function (e) {
                e.stopImmediatePropagation();
                that.closeChart();
            })
        });
    }

    closeChart() {
        baseController.closeSimpleMenu();
        $(".my-knowledge").each(function () {
            $('.stackable').last().remove();
        });
        $('.stackable').last().show();
    }

    openSubChart() {
        const that = this;

        $(document).on('click.subcategoriesChartMyKnowledge', "#my-knowledge-list .element-with-subcategories", function () {
            let catId = $(this).data('category');
            that.loadSubcategoryInfo(that.catList, catId);
        });
    }
}

